module.exports = __webpack_public_path__ + "img/img1.f7f98e32.png";